import FbButton from 'components/FbUI/FbButton'
import { cn } from 'components/UI/cn'
import React from 'react'

export interface DataTableFilterButtonsProps {
  isActive: boolean
  open: boolean
  title: string
  activeValueLabel: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  twoLineLayout?: boolean
}

const FilterButtonComponent = React.forwardRef(
  (props: DataTableFilterButtonsProps, ref) => {
    const showTwoLines =
      props.twoLineLayout && props.isActive && props.activeValueLabel !== 'All'

    return (
      <FbButton
        ref={ref}
        variant={'secondary'}
        type="button"
        className={cn(
          'flex-1 w-100 relative min-h-[40px] px-3 !py-0 rounded-lg',
          'text-fg hover:text-fg',
          '!border !border-gray-300',
          {
            // Open state
            '!bg-surface-raised !border-brand-active shadow-[0px_1px_2px_rgba(6,81,47,0.05)]':
              props.open,
            // Active with value (two-line layout)
            '!bg-surface-raised !border-brand shadow-[0px_1px_2px_rgba(16,24,40,0.05)]':
              showTwoLines && !props.open,
            // Active without two-line layout
            '!border-[#5a755e]': props.isActive && !props.open && !showTwoLines,
          }
        )}
        onClick={props.onClick}
      >
        {showTwoLines ? (
          // Two-line layout when active
          <div
            className={cn('w-full text-left flex flex-col gap-1', {
              'pr-8': props.isActive,
            })}
          >
            <span className="text-xs font-normal leading-3">{props.title}</span>
            <span className="overflow-hidden whitespace-nowrap overflow-ellipsis text-xs font-semibold leading-3">
              {props.activeValueLabel}
            </span>
          </div>
        ) : (
          // Single-line layout (default/open)
          <div
            className={cn('w-full text-left', {
              'pr-8': props.isActive,
            })}
          >
            <span className="text-base font-normal">{props.title}:</span>
            <span className="text-base font-semibold">
              &nbsp;{props.activeValueLabel}
            </span>
          </div>
        )}
      </FbButton>
    )
  }
)
FilterButtonComponent.displayName = 'FilterButton'

export const FilterButton = FilterButtonComponent
